let html = `<div class="items-line layer--visible layer--render">
    <div class="items-line__head">
        <div class="items-line__title">{title}</div>
    </div>
    <div class="items-line__body"></div>
</div>`

export default html